import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Datafield } from 'src/app/models/database/datafield.model';
import { DatasheetBuilderService } from 'src/app/services/datasheet-builder/datasheet-builder.service';
import { DatafieldAttributes, DatasheetService } from 'src/app/services/datasheet/datasheet.service';
import { DatafieldsEnum } from '../datafield.enum';
import { IDatafieldComponent } from '../datafield.interface';

@Component({
  selector: 'app-datafield-checklist',
  templateUrl: './datafield-checklist.component.html',
  styleUrls: ['./datafield-checklist.component.scss']
})
export class DatafieldChecklistComponent implements OnInit, OnDestroy, IDatafieldComponent {

  formGroup: FormGroup
  formGroupSubmitted: boolean = false
  label: string
  session: string
  list: string[]
  value: any
  datafield: Datafield
  forRecord: boolean
  subscriptionManager: Subscription = new Subscription()

  constructor(
    private datasheetService: DatasheetService,
    private formBuilder: FormBuilder,
    public datasheetBuilderService: DatasheetBuilderService
  ) { }

  ngOnInit(): void {
    let formGroupSkeleton = {}
    for (let item of this.list) {
      formGroupSkeleton[item.split(' ').join('_')] = this.formBuilder.control(false, [Validators.required])
      if (this.value) {
        formGroupSkeleton[item.split(' ').join('_')].setValue(this.value[this.list.indexOf(item)])
      }
    }
    this.formGroup = this.formBuilder.group(formGroupSkeleton)
    if (this.value) {
      this.formGroup.disable()
    }
    this.subscriptionManager.add(this.datasheetService.datafieldValidationSubject
      .pipe(tap(() => {
        this.formGroupSubmitted = true
        if (this.formGroup.invalid) {
          this.datasheetService.everythingIsValid = false
          return
        }
        this.formGroupSubmitted = false
      })).subscribe())
    this.subscriptionManager.add(this.datasheetService.datasheetObjectBuilder$.pipe(
      tap(() => {
        const datafieldAttributes: DatafieldAttributes =
          new DatafieldAttributes(DatafieldsEnum.CHECKLIST, this.label, this.formGroup.value, this.list)
        this.datasheetService.buildDatasheetObject(this.session, datafieldAttributes)
      })
    ).subscribe())
  }

  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe()
  }
}
